exports = module.exports = require("../../../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".driverInfo{margin-top:1.5rem;border-top-style:dashed;border-width:.07143rem;color:#d8ddeb}.driverInfo img{width:4rem;height:4rem}\n", ""]);

// exports
